import React from 'react'
import ResponsivePopover from '@/components/molecules/ResponsivePopover/ResponsivePopover'
import { getProfileCenterPopoverDescription } from '@/domain/primaryFocus/useCases/getProfileCenterPopoverDescription'
import IconChevronDownXs from '@/components/icons/IconChevronDownXs/IconChevronDownXs'
import LinkButton from '@/components/atoms/LinkButton/LinkButton'

export interface CenterPrimaryFocusDisclaimerProps {
  primaryFocus: string
  coOccurringDisorder?: string
  className?: string
}

const CenterPrimaryFocusDisclaimer: React.FC<
  CenterPrimaryFocusDisclaimerProps
> = ({ primaryFocus, coOccurringDisorder, className = '' }) => {
  const popoverDescription = getProfileCenterPopoverDescription(
    primaryFocus,
    coOccurringDisorder
  )

  const treatmentFocus = [primaryFocus, coOccurringDisorder]
    .filter(Boolean)
    .join(' and ')
    .trim()

  return (
    <div
      className={`flex flex-col items-start justify-between gap-2 rounded-lg bg-gray-50 p-4 text-sm text-gray-1100 md:flex-row ${className}`}
    >
      <div>
        <span className="font-semibold">Treatment Focus:</span> {treatmentFocus}
      </div>
      <ResponsivePopover
        header="Treatment Focus"
        description={popoverDescription}
      >
        <LinkButton
          label="What does this mean?"
          iconElement={
            <IconChevronDownXs
              strokeWidth="0.2"
              className="text-black"
            />
          }
        />
      </ResponsivePopover>
    </div>
  )
}

export default CenterPrimaryFocusDisclaimer
